import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE, DESC_ORDER } from "@duosoftbg/nacid-components";
import { GlobalFilterDetails } from "../types/globalMessageTypes";

export const globalMessageFilterInitialValues: GlobalFilterDetails = {
  name: "",
  nameEn: "",
  text: "",
  textEn: "",
  createdDateFrom: undefined,
  createdDateTo: undefined,
  lastUpdateDateFrom: undefined,
  lastUpdateDateTo: undefined,
  globalMessageType: "",
  enabled: "",
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  order: DESC_ORDER,
  orderBy: "createdDate",
};
